export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/devices.8ee40b2d-0596ee.png";